<template>
  <div class="BannerDialog pa-3" :class="{is_open: open}">
    <slot></slot>
    <slot name="action"></slot>
  </div>
</template>

<script>
export default {
  name: 'BannerDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.BannerDialog{
  position: absolute;
  top: -1000px;
  left: 50%;
  opacity: 0;
  visibility: hidden;
  z-index: 1000;
  transform: translate(-50%, 0);
  background: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
  padding: $spacer * 3.5  $spacer * 5.5;
  transition: all 0.5s;
  width: 50%;
  max-width: 600px;
  min-width: 300px;

  &.is_open{
    top: 80px;
    opacity: 1;
    visibility: visible;
  }
}
</style>
